import { constants } from "@newsela/angelou";

import {
  annotationColors,
  annotationColorsLighter,
  annotationColorsDarker,
  annotationPenNameValues,
} from "./AnnotatedText.constants";

const { ui } = constants.colors;

const greyDark = ui.neutral[700];

// Adds visual focus to any nodes when the anchor tag is focused.
export const focusTextCss = (isStartInNode, isEndInNode) => ({
  // The blur property (third in each box shadow) was added to fix
  // a bug with multi-line annotations in Chrome.
  // Left, top, bottom, right.
  boxShadow: `
    ${isStartInNode ? `-1px 0 1px 0 ${greyDark},` : ""}
    0 -1px 1px 0 ${greyDark},
    0 1px 1px 0 ${greyDark}
    ${isEndInNode ? `, 1px 0 1px 0 ${greyDark}` : ""}
  `,
});

// To be used in ProseMirrorText on annotated text nodes.
export const annotatedTextCss = ({ penName, isSelected = false }) => {
  const color = annotationPenNameValues[penName];

  return {
    background: isSelected
      ? annotationColors[color]
      : annotationColorsLighter[color],
    borderBottom: `2px solid ${annotationColorsDarker[color]}`,
    cursor: "pointer",

    "&:hover": {
      background: annotationColors[color],
    },
  };
};
